import AutoSizer from 'react-virtualized-auto-sizer';
import { FixedSizeList } from 'react-window';
import InfiniteLoader from 'react-window-infinite-loader';

import columnMappings from '~/components/columnMappings';
import ColumnSelectorMenu from '~/components/DynamicTable/ColumnSelectorMenu';
import DynamicTable from '~/components/DynamicTable/DynamicTable';
import EmptyPlaceholder from '~/components/EmptyPlaceholder';
import EmptySearch from '~/components/EmptySearch';
import EmptySegmentPlaceholder from '~/components/EmptySegmentPlaceholder';
import LoadingArea from '~/components/LoadingArea';
import loader from '~/images/loader.png';

import Person from './Person';
import styles from './styles';

const listItemHeight = 58;

function PeopleList({
  classes,
  columns,
  integrate,
  loading,
  onLoadMore,
  people,
  peopleHasNextPage,
  peopleTotalCount,
  refetchQuery,
  searchQuery,
  segmentId,
}) {
  const areItemsEmpty = peopleTotalCount === 0;

  const isItemLoaded = (index) => {
    return !peopleHasNextPage || index < people.length;
  };

  let emptyPlaceholder;

  if (segmentId && !searchQuery) {
    emptyPlaceholder = (
      <EmptySegmentPlaceholder
        segmentType="Person"
        segmentId={segmentId}
        searchQuery={searchQuery}
      />
    );
  } else if (searchQuery) {
    emptyPlaceholder = (
      <EmptySearch
        segmentType="Person"
        searchQuery={searchQuery}
        inSegment={segmentId !== undefined}
      />
    );
  } else {
    emptyPlaceholder = <EmptyPlaceholder integrate={integrate} />;
  }

  if ((loading && !people) || people.length == 0)
    return (
      <LoadingArea
        empty={areItemsEmpty}
        loading={loading}
        emptyBody={emptyPlaceholder}
      />
    );

  return (
    <div className={classes.root}>
      <DynamicTable
        actions={
          <ColumnSelectorMenu
            columns={columns}
            type="Person"
            onColumnsChanged={(columns) => columns && refetchQuery()}
            segmentId={segmentId}
          />
        }
        columnMapping={columnMappings}
        columns={columns}>
        <AutoSizer>
          {({ height, width }) => (
            <InfiniteLoader
              isItemLoaded={isItemLoaded}
              itemCount={peopleTotalCount}
              loadMoreItems={onLoadMore}>
              {({ onItemsRendered, ref }) => (
                <FixedSizeList
                  height={height}
                  itemCount={people.length}
                  itemSize={listItemHeight}
                  onItemsRendered={onItemsRendered}
                  ref={ref}
                  width={width}>
                  {(listProps) => (
                    <Person
                      columns={columns}
                      person={people[listProps.index]}
                      segmentId={segmentId}
                      {...listProps}
                    />
                  )}
                </FixedSizeList>
              )}
            </InfiniteLoader>
          )}
        </AutoSizer>
      </DynamicTable>

      {loading && <img alt="" className={classes.loader} src={loader} />}
    </div>
  );
}

PeopleList.propTypes = {
  classes: PropTypes.object.isRequired,
  columns: PropTypes.arrayOf(PropTypes.string).isRequired,
  integrate: PropTypes.bool,
  loading: PropTypes.bool,
  onLoadMore: PropTypes.func.isRequired,
  people: PropTypes.array,
  peopleHasNextPage: PropTypes.bool,
  peopleTotalCount: PropTypes.number,
  refetchQuery: PropTypes.func.isRequired,
  searchQuery: PropTypes.string,
  segmentId: PropTypes.string,
};

export default withStyles(styles)(PeopleList);
